import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useReduxData from "../../../Hooks/useReduxData";
import { toast } from "react-toastify";
import { RoleTitle } from "../../../Context/constants";
import { useFormik } from "formik";
import { medicineValidation, inventoryValidation, addAndReleaseStockValidation } from "../../../Context/Validation";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ARCHIVE_MEDICINE, EXPORT_MEDICINE, IMPORT_MEDICINE, INSERT_MEDICINE, MEDICINE_LIST, UPDATE_MEDICINE, LIST_INVENTORY, INSERT_INVENTORY, UPDATE_INVENTORY, LIST_VENDOR, ARCHIVE_VENDOR, ARCHIVE_INVENTORY, DOWNLOAD_INVENTORY, DOWNLOAD_VENDOR, STOCK_HISTORY_INVENTORY, ADD_RELEASE_INVENTORY } from "../../Repository/SettingRepo";

const useMedicine = () => {
    const [loader, setLoader] = useState(false)
    const [TotalCount, setTotalCount] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: null });
    const [inventoryController, setInventoryController] = useState({ page: 1, rowsPerPage: 10, searchPage: null });
    const [vendorController, setVendorController] = useState({ page: 1, rowsPerPage: 10, searchPage: null });
    const [medicineList, setMedicineList] = useState([])
    const [inventoryList, setInventoryList] = useState([])
    const [vendorList, setVendorList] = useState([])
    const [importFile, setImportFile] = useState(null)
    const [Filter, setFilter] = useState({
        archive: true,
        search: "",
        disable_button: true
    })
    const [inventoryFilter, setInventoryFilter] = useState({
        inventoryArchive: true,
        inventorySearch: "",
        inventory_disable_button: true
    })
    const [vendorFilter, setVendorFilter] = useState({
        vendorArchive: true,
        vendorSearch: "",
        vendor_disable_button: true
    })
    const [openModal, setOpenModal] = useState({
        addMedicine: false,
        importMedicine: false,
        archive: false,
        addInventory: false,
        addStock: false,
        releaseStock: false,
        addVendor: false,
        data: null,
        comeFromInventory: false,
    })
    const navigate = useNavigate()
    const { reduxData: userdata } = useReduxData("userDataRDX")
    const excelref = useRef()

    const location = useLocation();
    const [tab, setTab] = useState(location.state?.tab || 1);

    const ChangeTab = (Type) => {
        switch (Type) {
            case "generalMedicine":
                setTab(1)
                break;
            case "inventory":
                setTab(2)
                break;
            case "vendorManagement":
                setTab(3)
                break;
            default: setTab(1)
        }
    }


    const headCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", isShorted: false },
        { id: "name", numeric: true, disablePadding: false, label: " Medicine  Name", isShorted: true },
        { id: "abbr", numeric: true, disablePadding: false, label: "Abbreviation", isShorted: true },
        { id: "brandName", numeric: true, disablePadding: false, label: "Brand Name", isShorted: true },
        { id: "medicineType", numeric: true, disablePadding: false, label: "Medicine Type", isShorted: true },
        { id: "Strength", numeric: true, disablePadding: false, label: "Strength", isShorted: true },
        { id: "reaction", numeric: true, disablePadding: false, label: "Reaction", isShorted: true },
        { id: "action", numeric: false, disablePadding: false, showLeft: true, label: "Action", isShorted: false },
    ];

    const headInventoryCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", isShorted: false },
        { id: "batchNumber", numeric: true, disablePadding: false, label: " Batch Number", isShorted: true },
        { id: "productName", numeric: true, disablePadding: false, label: " Product Name", isShorted: true },
        { id: "category", numeric: true, disablePadding: false, label: " category", isShorted: true },
        { id: "manufactureDate", numeric: true, disablePadding: false, label: "Manufacture Date", isShorted: true },
        { id: "expiryDate", numeric: true, disablePadding: false, label: "Expiry Date", isShorted: true },
        { id: "shelfLife", numeric: true, disablePadding: false, label: "Shelf Life", isShorted: true },
        { id: "quantity", numeric: true, disablePadding: false, label: "Quantity", isShorted: true },
        { id: "vendorName", numeric: true, disablePadding: false, label: "Vendor Name", isShorted: true },
        { id: "vendorStatus", numeric: true, disablePadding: false, label: "Vendor Status", isShorted: true },
        { id: "action", numeric: false, disablePadding: false, showLeft: true, label: "Action", isShorted: false },
    ];

    const headVendorCells = [
        { id: "#", numeric: false, disablePadding: true, label: "#", isShorted: false },
        { id: "vendorId", numeric: true, disablePadding: false, label: "Vendor ID", isShorted: true },
        { id: "name", numeric: true, disablePadding: false, label: "Vendor/Company Name", isShorted: true },
        { id: "category", numeric: true, disablePadding: false, label: " category", isShorted: true },
        { id: "mobile", numeric: true, disablePadding: false, label: " Mobile Number", isShorted: true },
        { id: "email", numeric: true, disablePadding: false, label: "E-mail", isShorted: true },
        // { id: "gstNumber", numeric: false, disablePadding: false, label: "GST No.", isShorted: true },
        // { id: "panNumber", numeric: false, disablePadding: false, label: "PAN No.", isShorted: true },
        { id: "taxregistrationNumber", numeric: false, disablePadding: false, label: "Tax Registration No.", isShorted: true },
        { id: "action", numeric: false, disablePadding: false, showLeft: true, label: "Action", isShorted: false },
    ];



    async function getMedicineList() {
        setLoader(true)
        const { page, rowsPerPage, searchPage } = controller;
        const { archive, search } = Filter;
        const keyword = search.trim();
        const payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            page: page,
            count: rowsPerPage,
            activeStatus: archive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        };
        try {
            let response = await MEDICINE_LIST(payload)
            setMedicineList(response?.data)
            setTotalCount(response?.totalCount)
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setMedicineList([])
            setTotalCount(0)
            setLoader(false)
        }
    }

    async function getFullMedicineList() {
        setLoader(true)
        const { archive, search } = Filter;
        const payload = {
            activeStatus: archive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        };
        try {
            let response = await MEDICINE_LIST(payload)
            setMedicineList(response?.data?.map((cur) => ({ ...cur, medicine: `${cur?.name} (${cur?.dose} ${cur?.unit}) - ${cur?.medicineType} (${cur?.brandName})` })));
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setMedicineList([])
            setLoader(false)
        }
    }

    const handleAddMedicine = useFormik({
        initialValues: {
            name: "",
            reaction: "",
            unit: "",
            dose: "",
            medicineType: "",
            brandName: "",
            abbr: ""
        },
        validationSchema: medicineValidation,
        onSubmit: async (values) => {
            const { clone, ...restValue } = values
            setLoader(true)
            let payload = {
                providerId: openModal?.data ? undefined : (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
                frontdeskId: openModal?.data ? undefined : userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
                roleTitle: openModal?.data ? undefined : userdata.roleTitle,
                ...restValue,
            }
            try {
                let response = (openModal?.data && !clone) ? await UPDATE_MEDICINE(payload) : await INSERT_MEDICINE(payload)
                toast.success(response.message)
                setLoader(false)
                getMedicineList()
                handleClosedModal("addMedicine")
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        }
    })
    const handleOpenModal = (type, data = null) => {
        if (type === "addMedicine" && data) {
            let { activeStatus, selected, ...restValue } = data
            handleAddMedicine.setValues(restValue)
        }

        if (type === "addInventory" && data) {
            let { selected, ...restValue } = data
            handleAddInventory.setValues({ restValue })
        }
        setOpenModal((prev) => ({
            ...prev,
            data: data,
            [type]: true,
        }));
    };
    // const handleClosedModal = (type) => {
    //     if (type === "addMedicine") handleAddMedicine.resetForm()
    //     if (type === "addInventory") handleAddInventory.resetForm()
    //     setOpenModal((pre) => ({
    //         ...pre,
    //         data: null,
    //         [type]: false
    //     }))
    // }
    const handleClosedModal = (type) => {
        if (type === "addMedicine") handleAddMedicine.resetForm();

        setOpenModal((pre) => {
            const newState = {
                ...pre,
                data: null,
                [type]: false,
            };

            if (type === "addMedicine" && pre.comeFromInventory) {
                newState.addInventory = true;
                newState.data = pre.previoursData || null;
                newState.comeFromInventory = false;
                newState.previoursData = null;
            }

            if (type === "addInventory" && !pre.comeFromInventory) {
                handleAddInventory.resetForm();
            }

            if (type === "addStock" || type === "releaseStock") {
                handleAddAndReleaseStock.resetForm();
            }

            return newState;
        });
    };


    const archiveUnarchive = async (event) => {
        if (event === "YES") {
            setLoader(true)
            let payload = {
                medicineId: openModal?.data?.medicineId,
                activeStatus: !openModal?.data?.activeStatus,
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
            }
            try {
                let response = await ARCHIVE_MEDICINE(payload)
                toast.success(response.message)
                if (medicineList?.length === 1 && controller.page === 1) {
                    getMedicineList()
                }
                else if (medicineList?.length === 1) {
                    setController((pre) => ({ ...pre, page: controller.page > 1 ? controller.page - 1 : 1 }))
                } else getMedicineList()
                setLoader(false)
                handleClosedModal("archive")
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        } else {
            handleClosedModal("archive")
        }

    }
    const uploadExcel = async (event) => {
        const fileData = event;
        const excelTypes = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ];
        if (!excelTypes.includes(fileData?.type)) {
            return toast.warn("Only Excel file format allowed");
        }
        excelref.current.value = null;
        setImportFile(fileData);

    };
    // const handleExportMedicine = async () => {
    //     setLoader(true)
    //     const { searchPage } = controller;
    //     const { archive, search } = Filter;
    //     const keyword = search.trim();
    //     const payload = {
    //         keyword: (searchPage && keyword) ? keyword : undefined,
    //         // page: page,
    //         // count: rowsPerPage,
    //         activeStatus: archive,
    //         providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
    //         frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
    //     };
    //     try {
    //         let response = await EXPORT_MEDICINE(payload)
    //         window.open(response?.filePath)
    //         toast.success("Excel file downloaded successfully")
    //         setLoader(false)
    //     } catch (error) {
    //         toast.error(error.message)
    //         setLoader(false)
    //     }
    // }

    const handleExportMedicine = async () => {
        setLoader(true)

        const { searchPage } = controller
        const { archive, search } = Filter
        const keyword = search.trim()

        const payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            activeStatus: archive,
            providerId:
                userdata.roleTitle === RoleTitle.FRONT_DESK
                    ? userdata?.providerId
                    : userdata?.userId,
            frontdeskId:
                userdata.roleTitle === RoleTitle.FRONT_DESK
                    ? userdata?.userId
                    : undefined,
        }

        try {
            const response = await EXPORT_MEDICINE(payload)

            const contentType = response.headers["content-type"];

            if (contentType && contentType.includes("application/json")) {
                const text = await response.data.text();
                console.log("raw text ", text);

                if (!text) {
                    toast.error("No data found");
                    return;
                }

                try {
                    const errorObj = JSON.parse(text);
                    toast.error(errorObj.message || "No data found");
                } catch (e) {
                    console.error("JSON parse failed", e);
                    toast.error("No data found");
                }
                return;
            }

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement("a")

            link.href = url
            link.download = `medicine_${payload.providerId}.xlsx`
            document.body.appendChild(link)
            link.click()

            link.remove()
            window.URL.revokeObjectURL(url)

            toast.success("Excel file downloaded successfully")
        } catch (error) {
            toast.error("Failed to download file")
        } finally {
            setLoader(false)
        }
    }


    const handleImportMedicine = async (file) => {
        setLoader(true)
        const fd = new FormData();
        fd.append('files', importFile);
        fd.append('providerId', (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId)
        fd.append('frontdeskId', userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined)
        fd.append('roleTitle', userdata.roleTitle)
        try {
            let response = await IMPORT_MEDICINE(fd)
            toast.success(response.message)
            getMedicineList()
            setLoader(false)
            handleClosedModal("importMedicine")
            setImportFile(null)
            excelref.current.value = null;
        } catch (error) {
            toast.error(error.message)
            setLoader(false)
        }
    }

    // inventory
    const handleAddInventory = useFormik({
        enableReinitialize: true,
        initialValues: {
            batchNumber: openModal?.data?.batchNumber || "",
            quantity: openModal?.data?.quantity || "",
            manufactureDate: openModal?.data?.manufactureDate || "",
            expiryDate: openModal?.data?.expiryDate || "",
            productName: openModal?.data?.productName || "",
            marketPrice: openModal?.data?.marketPrice || "",
            purchasePrice: openModal?.data?.purchasePrice || "",
            sellingPrice: openModal?.data?.sellingPrice || "",
            category: openModal?.data?.category || "",
            type: openModal?.data?.productType || "",
            unit: openModal?.data?.productUnit || "",
            strength: openModal?.data?.strength || "",
            brandName: openModal?.data?.productBrandName || "",
            reOrderLevel: openModal?.data?.reOrderLevel || "",
            vendorId: openModal?.data?.vendorId || "",
        },
        validationSchema: inventoryValidation,
        onSubmit: async (values) => {
            const { clone, ...restValue } = values
            setLoader(true)
            let payload = {
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
                frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
                roleTitle: userdata.roleTitle,
                inventoryId: openModal?.data?.inventoryId,
                ...restValue,
            }
            try {
                let response = (openModal?.data && !clone) ? await UPDATE_INVENTORY(payload) : await INSERT_INVENTORY(payload)
                toast.success(response.message)
                setLoader(false)
                getInentoryList()
                handleClosedModal("addInventory")
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        }
    })

    async function getInentoryList() {
        setLoader(true)
        const { page, rowsPerPage, searchPage } = inventoryController;
        const { inventoryArchive, inventorySearch } = inventoryFilter;
        const keyword = inventorySearch.trim();
        const payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            page: page,
            count: rowsPerPage,
            activeStatus: inventoryArchive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        };
        try {
            let response = await LIST_INVENTORY(payload)
            setInventoryList(response?.data)
            setTotalCount(response?.totalCount)
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setInventoryList([])
            setTotalCount(0)
            setLoader(false)
        }
    }

    async function archiveInventory(event) {
        if (event === "YES") {
            setLoader(true)
            let payload = {
                inventoryId: openModal?.data?.inventoryId,
                activeStatus: !openModal?.data?.activeStatus,
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
            }
            try {
                let response = await ARCHIVE_INVENTORY(payload)
                toast.success(response.message)
                if (inventoryList?.length === 1 && inventoryController.page === 1) {
                    getInentoryList()
                }
                else if (inventoryList?.length === 1) {
                    setInventoryController((pre) => ({ ...pre, page: inventoryController.page > 1 ? inventoryController.page - 1 : 1 }))
                } else getInentoryList()
                setLoader(false)
                handleClosedModal("archive")
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        } else {
            handleClosedModal("archive")
        }
    }

    const handleAddAndReleaseStock = useFormik({
        initialValues: {
            quantity: "",
        },
        validationSchema: addAndReleaseStockValidation,
        onSubmit: async (values) => {
            console.log("Submitting payload", values);
            setLoader(true)
            let payload = {
                ...values,
                action: openModal?.addStock ? "add" : "release",
                inventoryId: openModal?.data?.inventoryId,
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
                frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
            }
            console.log("Final payload:", payload);
            try {
                let response = await ADD_RELEASE_INVENTORY(payload)
                toast.success(response.message)
                await getInentoryList()
                handleAddAndReleaseStock.resetForm()
                handleClosedModal("addStock", true)
                handleClosedModal("releaseStock", true)
                setLoader(false)
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        }
    })


    // const handleDownloadInventory = async () => {
    //     setLoader(true)
    //     const { searchPage } = inventoryController;
    //     const { inventoryArchive, inventorySearch } = inventoryFilter;
    //     const keyword = inventorySearch.trim();
    //     const payload = {
    //         keyword: (searchPage && keyword) ? keyword : undefined,
    //         // page: page,
    //         // count: rowsPerPage,
    //         activeStatus: inventoryArchive,
    //         providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
    //         frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
    //     };
    //     try {
    //         let response = await DOWNLOAD_INVENTORY(payload)
    //         window.open(response?.filePath)
    //         toast.success("Excel file downloaded successfully")
    //         setLoader(false)
    //     } catch (error) {
    //         toast.error(error.message)
    //         setLoader(false)
    //     }
    // }

    const handleDownloadInventory = async () => {
        setLoader(true);
        const { searchPage } = inventoryController;
        const { inventoryArchive, inventorySearch } = inventoryFilter;
        const keyword = inventorySearch.trim();

        const payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            activeStatus: inventoryArchive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK)
                ? userdata?.providerId
                : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK
                ? userdata?.userId
                : undefined,
        };

        try {
            let response = await DOWNLOAD_INVENTORY(payload);

            const contentType = response.headers["content-type"];

            if (contentType && contentType.includes("application/json")) {
                const text = await response.data.text();
                console.log("raw text ", text);

                if (!text) {
                    toast.error("No data found");
                    return;
                }

                try {
                    const errorObj = JSON.parse(text);
                    toast.error(errorObj.message || "No data found");
                } catch (e) {
                    console.error("JSON parse failed", e);
                    toast.error("No data found");
                }
                return;
            }

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `inventory_${payload.providerId}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            toast.success("Excel file downloaded successfully");
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoader(false);
        }
    };



    // vendor management
    async function getVendorList() {
        setLoader(true)
        const { page, rowsPerPage, searchPage } = vendorController;
        const { vendorArchive, vendorSearch } = vendorFilter;
        const keyword = vendorSearch.trim();
        const payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            page: page,
            count: rowsPerPage,
            activeStatus: vendorArchive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        };
        try {
            let response = await LIST_VENDOR(payload)
            setVendorList(response?.data)
            setTotalCount(response?.totalCount)
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setVendorList([])
            setTotalCount(0)
            setLoader(false)
        }
    }

    async function getFullVendorList() {
        setLoader(true)
        const { archive, search } = Filter;
        const payload = {
            activeStatus: archive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        };
        try {
            let response = await LIST_VENDOR(payload)
            setVendorList(response?.data?.map((cur) => ({ ...cur, vendor: `${cur?.firstName} ${cur?.lastName}` })));
            setLoader(false)
        } catch (error) {
            if (error.message !== "No details found") toast.error(error.message)
            setVendorList([])
            setLoader(false)
        }
    }

    async function archiveVendor(event) {
        if (event === "YES") {
            setLoader(true)
            let payload = {
                id: openModal?.data?.id,
                activeStatus: !openModal?.data?.activeStatus,
                providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
            }
            try {
                let response = await ARCHIVE_VENDOR(payload)
                toast.success(response.message)
                if (vendorList?.length === 1 && vendorController.page === 1) {
                    getVendorList()
                }
                else if (vendorList?.length === 1) {
                    setVendorController((pre) => ({ ...pre, page: vendorController.page > 1 ? vendorController.page - 1 : 1 }))
                } else getVendorList()
                setLoader(false)
                handleClosedModal("archive")
            } catch (error) {
                toast.error(error.message)
                setLoader(false)
            }
        } else {
            handleClosedModal("archive")
        }
    }

    const handleVendorInventory = async () => {
        setLoader(true);
        const { searchPage } = vendorController;
        const { vendorArchive, vendorSearch } = vendorFilter;
        const keyword = vendorSearch.trim();

        const payload = {
            keyword: (searchPage && keyword) ? keyword : undefined,
            // activeStatus: inventoryArchive,
            providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK)
                ? userdata?.providerId
                : userdata?.userId,
            frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK
                ? userdata?.userId
                : undefined,
        };


        try {
            let response = await DOWNLOAD_VENDOR(payload);

            const contentType = response.headers["content-type"];

            if (contentType && contentType.includes("application/json")) {
                const text = await response.data.text();
                console.log("raw text ", text);

                if (!text) {
                    toast.error("No data found");
                    return;
                }

                try {
                    const errorObj = JSON.parse(text);
                    toast.error(errorObj.message || "No data found");
                } catch (e) {
                    console.error("JSON parse failed", e);
                    toast.error("No data found");
                }
                return;
            }

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `vendor_${payload.providerId}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            toast.success("Excel file downloaded successfully");
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoader(false);
        }
    };


    const handleChangeFilter = (event) => {
        const { name, value } = event.target
        setFilter((pre) => ({ ...pre, disable_button: false, [name]: value }))
        setInventoryFilter((pre) => ({ ...pre, inventory_disable_button: false, [name]: value }))
        setVendorFilter((pre) => ({ ...pre, vendor_disable_button: false, [name]: value }))

    }
    const HandleSearchList = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
        setInventoryController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
        setVendorController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
    }
    const reset = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null }))
        setInventoryController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null }))
        setVendorController((pre) => ({ ...pre, page: pre.searchPage ?? pre.page, searchPage: null }))
        setFilter({ archive: true, search: "", disable_button: true })
        setInventoryFilter({ inventoryArchive: true, inventorySearch: "", inventory_disable_button: true })
        setVendorFilter({ vendorArchive: true, vendorSearch: "", vendor_disable_button: true })
    }

    useEffect(() => {
        if (tab === 1) {
            getMedicineList()
        }
        if (tab === 2) {
            getInentoryList()
        }
        if (tab === 3) {
            getVendorList()
        }
        navigate({ replace: true, state: null })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controller, inventoryController, vendorController, tab])
    return {
        data: {
            headCells,
            controller,
            inventoryController,
            vendorController,
            Filter,
            inventoryFilter,
            vendorFilter,
            TotalCount,
            medicineList,
            inventoryList,
            vendorList,
            loader,
            openModal,
            excelref,
            importFile,
            tab,
            headInventoryCells,
            headVendorCells,
            userdata,
        },
        methods: {
            handleChangeFilter,
            HandleSearchList,
            handleOpenModal,
            handleClosedModal,
            setController,
            setInventoryController,
            setVendorController,
            reset,
            archiveUnarchive,
            archiveVendor,
            archiveInventory,
            handleAddMedicine,
            handleAddInventory,
            handleAddAndReleaseStock,
            handleExportMedicine,
            handleImportMedicine,
            handleDownloadInventory,
            handleVendorInventory,
            uploadExcel,
            ChangeTab,
            getInentoryList,
            getFullVendorList,
            getVendorList,
            setOpenModal,

        }
    }
}

export default useMedicine
